import React from "react";
import img1 from "../../../assets/images/section2.jpg";
import img2 from "../../../assets/images/img2.jpg";
import img3 from "../../../assets/images/img3.jpg";

const DetailsSection = () => {
  return (
    <div className="space-y-10">
      <p className="text-center font-eb-garam text-5xl font-semibold text-[#730000]  max-lg:text-4xl max-sm:text-3xl">
        Connect with your prospect spouse and begin your forever{" "}
      </p>
      <div className="flex w-[80%] justify-center m-auto max-md:flex-wrap gap-8">
        <div className="space-y-6 w-[50%] max-md:w-[80%] self-center">
          <p className=" m-auto text-2xl max-lg:text-xl max-sm:text-[15px]">
            We understand that finding a life partner isn’t just about shared
            interests; it’s about finding someone who respects your ambitions,
            values your intellect, and complements your lifestyle.
            <br />
            We’re here to make the search for your soulmate easier, smarter, and
            more meaningful.
          </p>
          <hr className="w-[50%] m-auto border rounded my-4" />
        </div>
        <img
          src={img1}
          alt="Couple finding connection"
          className="w-[50%] max-md:w-full max-sm:h-[40vh] object-cover rounded shadow-md"
        />
      </div>
      <p className="text-center font-eb-garam text-5xl font-semibold text-[#730000] max-lg:text-4xl max-sm:text-3xl pt-20">
        Ditch the traditional rishta struggle{" "}
      </p>
      <div className="flex w-[80%] justify-center m-auto gap-8 max-md:flex-wrap ">
        <img
          src={img2}
          alt="Matching profiles"
          className="w-[50%] max-md:w-full h-[65vh] max-lg:h-[40vh] max-sm:h-[40vh] object-cover rounded shadow-md"
        />
        <div className="space-y-6 w-[50%] max-md:w-[80%] self-center">
          <p className=" m-auto text-2xl max-lg:text-xl max-sm:text-[15px]">
            We are focused on connecting educated profiles to have compatible
            and fulfilling life.
            <br />
            Select Proposal is not your average matrimonial platform; we’re here
            to redefine the way educated individuals find their perfect match.
            <br />
            Say goodbye to endless scrolling through mismatched profiles and
            hello to a smarter, more refined way to find the one.
          </p>
          <hr className="w-[50%] m-auto border rounded my-4" />
        </div>
      </div>
      <div className="flex">
        <div className="space-y-6">
          <p className="text-center font-eb-garam text-5xl font-semibold text-[#730000] max-lg:text-4xl max-sm:text-3xl pt-20">
            What We Do
          </p>
          <p className="w-[70%] m-auto text-center text-2xl max-lg:text-xl max-sm:text-[15px] pb-6 mb-6">
            Whether you’re an intellectual man who wants to have a spouse that
            has a balance of career and life. Or you are a woman who wants to
            have a spouse that shares similar values as yours; Select Proposal
            is a place that caters to your needs.
          </p>
          <p className="w-[100%] text-center font-eb-garam text-5xl font-semibold text-[#730000] max-lg:text-4xl max-sm:text-3xl pt-20">
            Find Love and lead a Happy Life.
          </p>
          <hr className="w-[50%] m-auto border rounded my-4" />
          <p className="text-center font-eb-garam text-5xl font-semibold text-[#730000] max-lg:text-4xl max-sm:text-3xl">
            Break the Rishta Struggle
          </p>
        </div>
      </div>
      
      <div className="flex w-[80%] justify-center m-auto gap-8 max-md:flex-wrap pt-5">
        <div className="space-y-6 w-[50%] max-md:w-[80%] self-center">
          <p className=" m-auto text-2xl max-lg:text-xl max-sm:text-[15px]">
            Let’s face it – the traditional rishta hunt is nothing but a
            struggle.
            <br />
            Endless family meetings, awkward introductions, and mismatched
            expectations can make the process exhausting. Our platform is
            designed to cut through the noise and connect you with educated,
            like minded individuals who are serious about marriage.
            <br />
            No more settling for less – we’re here to help you find someone who
            truly gets you. Say goodbye to the struggle and hello to a smarter,
            more efficient way to find love.
            <br />
          </p>
          <hr className="w-[50%] m-auto border rounded my-4" />
        </div>
        <img
          src={img3}
          alt="Finding true connection"
          className="w-[35%] max-md:w-full h-[70vh] max-lg:h-[35vh] max-sm:h-[40vh] object-cover rounded shadow-md"
        />
      </div>
      <div className="flex pt-20">
        <div className="space-y-6">
          <p className="text-center text-5xl font-bold text-[#730000] font-eb-garam max-lg:text-4xl max-sm:text-3xl">
            Why settle for ordinary when you can have extraordinary?
          </p>
          <p className="w-[70%] m-auto text-center text-2xl max-lg:text-xl max-sm:text-[14px] pb-6 mb-6">
            Our focus on educated profiles ensures that you’re matched with
            someone who shares your intellectual curiosity and life goals.
            <br />
            With verified profiles, advanced search filters, and a user friendly
            interface, we make the process of finding your soulmate seamless and
            enjoyable. Our commitment to privacy and security means you can
            focus on building connections without any worries.
          </p>
          <p className="w-[70%] m-auto text-[#730000] text-center font-bold text-5xl font-eb-garam max-lg:text-2xl max-sm:text-3xl pt-20">
            Your journey to forever starts here
          </p>
          <hr className="w-[50%] m-auto border rounded my-4" />
          <h2 className="text-center font-eb-garam text-5xl font-semibold text-[#730000]  max-lg:text-4xl max-sm:text-3xl">
            Love is in the air
          </h2>
        </div>
      </div>
    </div>
  );
};

export default DetailsSection;
